import React, { useEffect, useRef } from 'react';
import './CompanyLogos.css';

const logos = [
    "google_logo.svg",
    "amazon_logo.svg",
    "meta_logo.svg",
    "microsoft_logo.svg",
    "apple_logo.svg",
    "indeed_logo.svg",
    "dropbox_logo.svg",
    "netflix_logo.svg",
    "visa_logo.svg",
    "dell_logo.svg",
    "tiktok_logo.svg",
    "kpmg_logo.svg",
    "accenture_logo.svg",
    "uber_logo.svg",
    "gs_logo.svg",
    "oracle_logo.svg",
    "ibm_logo.svg",
    "usbank_logo.svg",
    "deloitte_logo.svg",
    "jp_logo.svg",
    "pwc_logo.svg",
    "intel_logo.svg",
    "salesforce_logo.svg",
    "cap_logo.svg"
];

const CompanyLogos = () => {
    const logosRef = useRef(null);

    useEffect(() => {
        const logosWidth = logosRef.current.scrollWidth;
        const animationDuration = logosWidth / 0.1; // Adjust this for speed, higher is slower.

        const keyframes = [
            { transform: 'translateX(0)' },
            { transform: `translateX(-${logosWidth / 2}px)` }, // Adjusting for half the width for duplication
        ];

        const animation = logosRef.current.animate(keyframes, {
            duration: animationDuration,
            iterations: Infinity,
            easing: 'linear',
        });

        return () => animation.cancel();
    }, []); // Empty dependency array means this effect runs once on mount

    return (
        <div className="company-logos-wrapper">
            <div className="company-logos" ref={logosRef}>
                {logos.map((logo, index) => (
                    <img key={index} src={`./${logo}`} alt={`${logo.split('_')[0]} Logo`} className="company-logo" />
                ))}
                {/* Duplicate logos for seamless looping */}
                {logos.map((logo, index) => (
                    <img key={`duplicate-${index}`} src={`./${logo}`} alt={`${logo.split('_')[0]} Logo`} className="company-logo" />
                ))}
            </div>
        </div>
    );
};

export default CompanyLogos;